<template>
    <div>
        <a-row class="my-3 d-flex " >
            <TransactionExport @getData="getData" class="mx-2" />
            <BalanceExport @getData="getData" class="mx-2" />
            <UserTransactionExport @getData="getData" class="mx-2" />

        </a-row>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول گزارشات اکسل</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style=" display: flex; align-items: center;justify-content: flex-end;">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                    
                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                        <a-col style="margin-top: 20px" :md="4">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>
                        
                            <a-col :md="5">
                                <label class="sr-only" for="inline-form-input-name">شروع بازه زمانی</label>
                                <date-picker v-model="search.start"></date-picker>
                            </a-col>
                            <a-col :md="5">
                                <label class="sr-only" for="inline-form-input-name">پایان بازه زمانی</label>
                                <date-picker v-model="search.end"></date-picker>
                            </a-col>
                           
                            <a-col :md="5">
                                <label class="sr-only" for="inline-form-input-name">نوع گزارش</label>
                                <select class="form-control" v-model="search.type">
                                    <option value="">انتخاب</option>
                                    <option value="transaction">تراکنش ها</option>
                                    <option value="user_transaction">تراکنش های کاربر</option>
                                    <option value="balance">موجودی</option>
                                </select>
                            </a-col>
                        
                            <a-col :md="5">
                                <label class="sr-only" for="inline-form-input-name">شناسه گزارش</label>
                                <input class="form-control" type="text" v-model="search.id">
                            </a-col>
                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">نوع</th>
                                        <th scope="col">شروع بازه زمانی</th>
                                        <th scope="col">پایان بازه زمانی</th>
                                        <th scope="col">وضعیت</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>
                                    
                                            <b-badge variant="light" class="text-dark">
                                                <span v-if="row . type == 'balance'">گزارش موجودی</span>
                                                <span v-else-if="row . type == 'transaction'">گزارش تراکنش ها</span>
                                                <span v-else>گزارش تراکنش کاربر</span>
                                            </b-badge>
                                        </td>
                                      
                                        <td>
                                            {{ row . start != null ? new Date(row . start) . toLocaleDateString('fa-IR') : '-' }}

                                        </td>
                                        <td>
                                            {{ row . end != null ? new Date(row . end) . toLocaleDateString('fa-IR') : '-' }}
                                        </td>
                                        <td>
                                            <b-badge v-if="row.status== 'success'" pill variant="info" class="bg-success">
                                               موفق</b-badge>
                                                <b-badge v-else-if="row.status== 'failed'" pill variant="info" class="bg-danger">
                                                ناموفق</b-badge>
                                                <b-badge v-else pill variant="info" class="bg-warning">
                                                در حال پردازش</b-badge>
                                        </td>
                                        <td>
                                            <a-button :disabled="row.status != 'success'" target="_blank"  :href="`https://api.aatcart.com/${row.path}`">
                                        <a-icon type="upload" />  دانلود اکسل  
                                    </a-button>
                                    <a-button
                        class="btn-outline-danger mr-5" 
                        shape="square"
                        icon="delete"
                        @click="deleteRow(`transactions/reports/delete/${row.id}`)"
                      ></a-button>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import TransactionExport from '../../components/Blocks/ExportTransaction.vue';
    import BalanceExport from '../../components/Blocks/ExportBalance.vue';
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
    import UserTransactionExport from '../../components/Blocks/ExportUserTransaction.vue';

    export default {
        components: {
            TransactionExport,
            BalanceExport,
            UserTransactionExport,
            datePicker: VuePersianDatetimePicker
        },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    type: "",
                    end: "",
                    start: "",
                    id: "",
                },
            };
        },
        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/transactions/reports/list?page=${this.currentPage}&&type=${this.search.type}&&end=${this.search.end}&&start=${this.search.start}&&id=${this.search.id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        console.log(response)
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            deleteRow(url) {
      this.$swal({
        title: "آیا از حذف اطلاعات اطمینان دارید؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "بله",
        denyButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          let _this = this;
          axios
            .get(url)
            .then(function (response) {
              _this.$toast.success("با موفقیت حذف شد.");
              _this.getData();
            })
            .catch(function (err) {
              _this.$root.handleAxiosError(err);
            });
        }
      });
    },
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
